import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FakeText, Typography } from '@totalsoft/rocket-ui';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip, IconButton } from '@mui/material';
import { Delete, Save } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReportFilterComponent from './ReportFilterComponent';
import ReportFilterSummaryComponent from './ReportFilterSummaryComponent';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ReportFiltersListComponent = ({
  reportFilters,
  loading,
  onPropertyChanged,
  onExpandedChanged,
  onSave,
  onDelete,
  dictionaryEditorTypes,
  validation
}) => {
  const [t] = useTranslation();

  return reportFilters.map((item, idx) => {
    const header = <ReportFilterSummaryComponent reportFilter={item} />;
    return (
      <Grid key={idx} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandedChanged(isExpanded, idx)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant='h6'> {item.filterCaption}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                      <Grid item>
                        <Tooltip title={t('Reports.Save')}>
                          <div>
                            <IconButton
                              color='primary'
                              onClick={onSave(idx)}
                              disabled={!item.changed || !(validation[idx] |> isValid) || (validation |> getErrors) !== ''}
                            >
                              <Save />
                            </IconButton>
                          </div>
                        </Tooltip>
                      </Grid>
                      <Grid item>
                        <Tooltip title={t('Tooltips.Delete')}>
                          <IconButton color='primary' onClick={onDelete(item, idx)}>
                            <Delete />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
            {!item.isExpanded && <div style={{ width: '100%' }}>{header}</div>}
          </AccordionSummary>
          <AccordionDetails>
            {loading ? (
              <FakeText lines={10} />
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography color='error'>{validation |> getErrors}</Typography>
                </Grid>
                <ReportFilterComponent
                  reportFilter={item}
                  index={idx}
                  onPropertyChanged={onPropertyChanged}
                  dictionaryEditorTypes={dictionaryEditorTypes}
                  validation={validation}
                />
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

ReportFiltersListComponent.propTypes = {
  reportFilters: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onPropertyChanged: PropTypes.func.isRequired,
  onExpandedChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  dictionaryEditorTypes: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default ReportFiltersListComponent;
